import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Pipe({
	name: 'safeUrl',
	standalone: true,
})

export class SafeUrlPipe implements PipeTransform {
	constructor(private readonly sanitizer: DomSanitizer) {}
	transform(base64: string | null | undefined, prefix: string = 'data:image/png;base64,'): SafeUrl | '' {
		if (!base64) {
			return '';
		}
		const imageUrl = `${prefix}${base64}`;
		return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
	}
}